<div class="recuadro-operador d-flex">
    <span class="mt-1">{{operador.nombre}}</span>
    <div class="icono-borrar seleccionable" (click)="borrarOperandoCmd.ejecutar()">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
<div class="arbol-operando">
    <div class="conexion flex-grow-1 mt-2 position-relative" *ngFor="let condicion of operador.condiciones">
        <div class="border-start position-absolute"
            [class.ultimo]="operador.tipoOperador === TipoOperadorEnum.UNARIO && operador.condiciones.length === 1"></div>
        <div class="border-bottom"></div>
        <app-condicion class="d-flex flex-grow-1" [condicion]="condicion" [encuesta]="encuesta" [pregunta]="pregunta"
            [item]="item">
        </app-condicion>
    </div>
    <div class="conexion flex-grow-1 mt-2 position-relative" *ngFor="let operador of operador.operadores">
        <div class="border-start position-absolute"
            [class.ultimo]="operador.tipoOperador === TipoOperadorEnum.UNARIO && operador.condiciones.length === 1 && operador.operadores.length === 1"></div>
        <div class="border-bottom"></div>
        <app-operador [operador]="operador" [encuesta]="encuesta" [pregunta]="pregunta"></app-operador>
    </div>
    <div class="conexion flex-grow-1 mt-2 position-relative"
        *ngIf="!(operador.tipoOperador === TipoOperadorEnum.UNARIO && (operador.condiciones.length + operador.operadores.length) === 1)">
        <div class="border-start position-absolute ultimo"></div>
        <div class="border-bottom"></div>
        <div ngbDropdown class="d-inline-block">
            <button type="button" class="btn btn-outline-primary dropdown-sin-flecha" id="dropdownOperandos"
                ngbDropdownToggle>
                <app-svg-icon icon="plus-lg"></app-svg-icon>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownOperandos">
                <button ngbDropdownItem *ngFor="let condicion of condiciones" (click)="agregarCondicion(condicion)">
                    Condicion - {{condicion.nombre}}
                </button>
                <button ngbDropdownItem *ngFor="let operador of operadores" (click)="agregarOperador(operador)">
                    Operador - {{operador.nombre}}
                </button>
            </div>
        </div>
    </div>
</div>
